<div fxLayout fxLayoutAlign="center center" class="hd--authenticate-progress">
    <div fxFlex="50%">
        <h2 class="mat-h2">Helpdesk Login...</h2>
        <mat-progress-bar mode="buffer"></mat-progress-bar>
    </div>
</div>
